<template>
  <label
    class="relative flex items-center justify-center w-full flex-none h-8 text-gray-brand-900 focus:outline-none transition-all"
    :class="[
      { 'text-brand-800 bg-gray-brand-200': checked },
      isLoadingSlot ? 'cursor-wait' : 'cursor-pointer hover:bg-gray-brand-100'
    ]"
  >
    <input
      :id="id"
      :value="id"
      type="radio"
      class="sr-only"
      :checked="checked"
      :disabled="isLoadingSlot"
      @click="!isLoadingSlot && clickedOption(id)"
    />
    <div class="flex flex-col items-center justify-center p-3 min-h-[2rem]">
      <template v-if="isLoadingSlot">
        <svg
          class="animate-spin h-5 w-5 text-brand-500"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
          <path
            class="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
      </template>
      <span v-else id="date-0-label" class="block text-xs font-medium text-gray-900 text-center">
        {{ fulfillmentSlotTimeRange }} {{ merchantTimeZoneAbbreviation }}
      </span>
    </div>
  </label>
</template>

<script>
let strftime = require('strftime')

export default {
  name: 'InfoRowSlotTime',
  components: {},
  props: {
    option: { type: Object, required: true },
    selectedOption: { default: undefined },
    merchantTimeZone: { type: String, default: '' },
    loadingSlotId: { type: [String, Number], default: null }
  },
  data: () => ({}),
  computed: {
    isLoadingSlot() {
      return this.loadingSlotId != null && this.id != null && this.id == this.loadingSlotId
    },
    merchantTZ() {
      return `(${this.merchantTimeZone})`
    },
    merchantAndBrowserTZMatches() {
      return this.merchantTimeZone === Intl.DateTimeFormat().resolvedOptions().timeZone
    },
    merchantTimeZoneAbbreviation() {
      if (!this.merchantAndBrowserTZMatches) {
        return `(${
          new Date()
            .toLocaleTimeString('en-US', { timeZone: this.merchantTimeZone, timeZoneName: 'short' })
            .split(' ')[2]
        })`
      }
    },
    browserTZ() {
      return new Date().toLocaleDateString(undefined, { day: '2-digit', timeZoneName: 'short' }).substring(4)
    },
    id() {
      return this.option.attributes?.id
    },
    checked() {
      return this.id == this.selectedOption
    },
    fulfillmentSlotTimeRange() {
      const startTime = new Date(
        new Date(this.option?.attributes?.arrives_beginning_estimate).toLocaleString('en-US', {
          timeZone: this.merchantTimeZone
        })
      )
      const endTime = new Date(
        new Date(this.option?.attributes?.arrives_ending_estimate).toLocaleString('en-US', {
          timeZone: this.merchantTimeZone
        })
      )
      if (startTime.toString() == endTime.toString()) {
        return strftime('%-I:%M', startTime) + strftime('%p', startTime).toLowerCase()
      } else if (startTime.getDate() === endTime.getDate()) {
        return (
          'Between ' +
          strftime('%-I:%M', startTime) +
          strftime('%p and ', startTime).toLowerCase() +
          strftime('%-I:%M', endTime) +
          strftime('%p', endTime).toLowerCase()
        )
      } else {
        return (
          strftime('Between %A at ', startTime) +
          strftime('%-I:%M and ', startTime) +
          strftime('%A, %B %-d at ', endTime) +
          strftime('%-I:%M', endTime)
        )
      }
    }
  },
  methods: {
    clickedOption(value) {
      this.$emit('clickedOption', value)
    }
  }
}
</script>
